import { Component } from '@angular/core';
import { NavigationEnd, Router, ActivatedRoute } from '@angular/router';
import { GoogleAnalyticsService } from './core/services/google-analytics.service';
import { delay } from 'rxjs/operators';
import { GA_MEASUREMENT_ID } from '@app/constants';
import { GIFT_CARD_REGISTRATION_PROGRAM, GIFT_ENROLL_PATH, NEW_ENROLL_PATH } from './shared/constants/text.constants';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    title = 'gooddog-helpline-enrollment';
    constructor(
        private gaService: GoogleAnalyticsService,
        private router: Router,
        private activeRoute: ActivatedRoute
    ) {
        this.trackGaNavigation();
    }

    private trackGaNavigation(): void {
        this.router.events.pipe(delay(1000)).subscribe(event => {
            if (event instanceof NavigationEnd) {
                const url = event.urlAfterRedirects;
                let gaPath = '';
                if (url === '/enroll' || url.split('?')[0] === '/enroll') {
                    const rpId = this.activeRoute.snapshot.queryParamMap.get('rp');
                    if (rpId && rpId === GIFT_CARD_REGISTRATION_PROGRAM) {
                        gaPath = GIFT_ENROLL_PATH;
                    } else {
                        gaPath = NEW_ENROLL_PATH;
                    }
                }
                const skipGa = localStorage.getItem('skipGA');
                localStorage.removeItem('skipGA');
                if (!skipGa || skipGa !== 'Y') {
                    this.gaService.trackNavigation(url + gaPath);
                }
            }
        });
    }
}
